export enum ERequestType {
    ISSUE = 'ISSUE',
    QUESTION_ORDER = 'QUESTION_ORDER',
    QUESTION_ACCOUNT = 'QUESTION_ACCOUNT',
    INVOICE_INQUIRY = 'Invoice Inquiry', // Explicitly demanded by webshop team / business
    MATERIAL_AND_PRICING = 'MATERIAL_AND_PRICING'
}

// these two enums need to be updated in tandem if new invoice subtypes are added
export enum InvoiceType {
    INVOICE_INQUIRY = ERequestType.INVOICE_INQUIRY
}
